import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import MenuModule from '@/modules/menu';
import editorModule from '@/modules/editor';
import DatatablesModule from '@/modules/datatables';
import FirebaseConfigModule from '@/modules/firebase_config';
import EmpresaModule from '@/modules/empresa';
import NotificacionesModule from '@/modules/notificaciones';
import SesionModule from '@/modules/sesion';
import SesionesModule from '@/modules/sesiones';
import TareasModule from '@/modules/tareas';
import TooltipsModule from '@/modules/tooltips';
import TemasModule from '@/modules/temas';
import PerfilesModule from '@/modules/perfiles';
import CiaModule from '@/modules/cia';
import EcommerceModule from '@/modules/ecommerce';

export default new Vuex.Store({
  modules: {
    menu: MenuModule,
    datatable: DatatablesModule,
    firebase_config: FirebaseConfigModule,
    empresa: EmpresaModule,
    notificaciones: NotificacionesModule,
    sesion: SesionModule,
    sesiones: SesionesModule,
    tareas: TareasModule,
    tooltips: TooltipsModule,
    temas: TemasModule,
    perfiles: PerfilesModule,
    cia: CiaModule,
    editor: editorModule,
    ecommerce: EcommerceModule
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js